module.exports = __webpack_public_path__ + "img/waiting.aeb71a00.png";